import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteDropdownComponent } from './auto-complete-dropdown.component';
import { IconModule } from '../icon/icon.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [AutoCompleteDropdownComponent],
    imports: [CommonModule, IconModule,FormsModule,ReactiveFormsModule],
    exports: [AutoCompleteDropdownComponent],
})
export class AutoCompleteDropdownModule {}